import {usePathname} from './useLocation';

const transformablePattern = {
  '%3F': '?',
  '%26': '&',
  '%3D': '=',
};

export const useRepairMarketingUrls = () => {
  const pathname = usePathname();

  const containsPattern = Object.keys(transformablePattern).some(pattern =>
    pathname.includes(pattern),
  );
  if (containsPattern) {
    const nextUrl = Object.entries(transformablePattern).reduce(
      (url, [pattern, value]) => {
        return url.replace(new RegExp(`${pattern}`, 'g'), value);
      },
      pathname,
    );
    if (nextUrl) {
      return nextUrl;
    }
  }

  if (pathname.includes('=')) {
    const [missingDelimiterPart, ...restParts] = pathname.split(/(=)/);
    const missingDelimiterPats = missingDelimiterPart!.split(/(\d[a-zA-Z])/);
    const exactCharsPart = missingDelimiterPats?.[1]?.split('');
    const fixedDelimiterPart = exactCharsPart?.join('?');

    if (fixedDelimiterPart) {
      missingDelimiterPats[1] = fixedDelimiterPart;
      const nextUrl = [...missingDelimiterPats, ...restParts].join('');
      return nextUrl;
    }
  }

  return undefined;
};
